<template>
  <div>
    <div>
      <el-radio v-model="form.kind" :label="1">文字</el-radio>
      <el-radio v-model="form.kind" :label="2">文章</el-radio>
    </div>
    <!--文章输入框-->
    <div v-show="form.kind === 1">
      <el-input
        type="textarea"
        class="reply-content"
        v-model="form.textContent"
        @change="update"
        maxlength="300"
        show-word-limit
      ></el-input>
      <div>
        <el-button type="text" @click="$emit('delete')">删除</el-button>
      </div>
    </div>
    <!--文章选择框-->
    <div v-show="form.kind === 2">
      <!--文章选择-->
      <div v-show="form.article.art_id === ''" class="upload" @click="handleOpenDialog">
        <div class="el-icon-plus"></div>
        <span>选择文章</span>
      </div>
      <el-dialog :visible.sync="dialogArticleVisible" title="选择文章" width="50%" center>
        <div class="input-container">
          <el-input
            placeholder="输入关键词搜索"
            suffix-icon="el-icon-search"
            v-model="searchKeyword"
            class="input"
          ></el-input>
          <el-button @click="getArticleList()">搜索</el-button>
        </div>
        <div v-loading="imgLoading" style="margin: 0 auto; width: 570px">
          <div v-for="(art, index) in articleList" :key="index" class="article-container">
            <el-image :src="art.cover_url" class="article-cover"></el-image>
            <el-radio class="checkbox" v-model="selectedIndex" :label="index">
              <span></span>
            </el-radio>
            <div class="article-title" :title="art.title">{{ art.title }}</div>
          </div>
        </div>
        <div style="margin-top: 20px; float: right">
          <el-pagination
            style="background-color: #ffffff"
            layout="prev, pager, next"
            :total="pageTotal"
            :page-size="pageSize"
            :current-page="pageIndex"
            @current-change="changeIndex"
          />
        </div>
        <div class="select-form-item button-container">
          <el-button class="dialog-button" plain @click="dialogArticleVisible = false">
            取消
          </el-button>
          <el-button class="dialog-button" plain type="primary" @click="handleSelectArticle">
            确认
          </el-button>
        </div>
      </el-dialog>

      <!--文章展示-->
      <div v-show="form.article.art_id !== ''" class="article-show">
        <div class="cover-container">
          <el-image :src="form.article.cover_url" class="article-cover"></el-image>
          <div class="cover-shadow" @click="handleOpenDialog">选择文章</div>
        </div>
        <div class="article-title">
          <span style="font-size: 18px">文章标题：</span>
          <br />
          <span>{{ form.article.title }}</span>
        </div>
      </div>
      <div>
        <el-button type="text" @click="$emit('delete')">删除</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleListApi } from '@/api/releaseManagement';
export default {
  name: 'Message',
  model: {
    prop: 'form',
    event: 'change',
  },
  props: {
    form: {
      type: Object,
      default() {
        return {
          kind: 1, // 消息内容类型，1文字，2文章
          textContent: '', // 消息文字内容
          article: {
            art_id: '', // 文章id
            title: '', // 文章标题
            content_source_url: '', // 文章url
            cover_url: '', // 文章封面url
            digest: '', // 文章摘要
          },
        };
      },
      kind: Number, // 消息内容类型，1文字，2文章
      textContent: String, // 消息文字内容
      article: {
        art_id: String, // 文章id
        title: String, // 文章标题
        content_source_url: String, // 文章url
        cover_url: String, // 文章封面url
        digest: String, // 文章摘要
      },
    },
  },
  data() {
    return {
      articleList: [],
      pageIndex: 1, // 分页参数
      pageTotal: 1,
      pageSize: 6,
      dialogArticleVisible: false,
      selectedIndex: 0, // 选择的文章在列表中的index
      imgLoading: false,
      firstOpen: true, // 判断是否是第一次打开窗口搜索，用于减少搜索次数
      searchKeyword: '', // 搜索
    };
  },
  computed: {},
  created() {},
  methods: {
    getArticleList() {
      this.imgLoading = true;
      getArticleListApi({
        page_size: this.pageSize,
        page_index: this.pageIndex,
        keyword: this.searchKeyword,
        app_ids: this.$route.query.app_id,
      }).then((res) => {
        this.articleList = res.art_list;
        this.pageTotal = res.total;
        this.imgLoading = false;
      });
    },
    handleOpenDialog() {
      this.dialogArticleVisible = true;
      if (this.firstOpen) {
        this.getArticleList();
        this.firstOpen = false;
      }
    },
    changeIndex(index) {
      this.pageIndex = index;
      this.getArticleList();
      this.selectedIndex = 0;
    },
    handleSelectArticle() {
      const art = this.articleList[this.selectedIndex];
      const { article } = this.form;
      console.log(art);
      console.log(this.form.article);
      article.art_id = art.art_id;
      article.title = art.title;
      article.digest = art.digest;
      article.content_source_url = art.content_source_url;
      article.cover_url = art.cover_url;
      this.update();
      this.dialogArticleVisible = false;
    },
    update() {
      this.$emit('change', this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.reply-content {
  width: 500px;
  height: 150px;
  .el-textarea__inner {
    height: 150px;
    resize: none;
  }
  .el-input__count {
    background: rgba(0, 0, 0, 0);
    bottom: -9px;
    right: 25px;
  }
}
.upload {
  width: 300px;
  height: 150px;
  border: 1px dashed #c2c2c2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .el-icon-plus {
    font-size: 22px;
  }
  span {
    font-size: 18px;
  }
}
.article-container {
  width: 150px;
  height: 100px;
  display: inline-block;
  position: relative;
  margin: 0 20px;
  .article-cover {
    width: 150px;
    height: 100px;
  }
  .article-title {
    position: relative;
    bottom: 18px;
    width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: center;
    white-space: nowrap;
  }
  .checkbox {
    position: absolute;
    top: 5px;
    right: -30px;
    z-index: 55;
  }
}
.article-show {
  height: 150px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .cover-container {
    width: 200px;
    height: 120px;
    position: relative;
    .article-cover {
      width: 200px;
      height: 120px;
      border-radius: 10px;
    }
    .cover-shadow {
      width: 100%;
      height: 100%;
      border-radius: 10px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      font-size: 20px;
      color: rgba(0, 0, 0, 0);
      background-color: rgba(0, 0, 0, 0);
      transition: all 300ms;

      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .cover-container:hover {
    .cover-shadow {
      color: rgb(241, 239, 239);
      background-color: rgba(0, 0, 0, 0.3);
      cursor: pointer;
    }
  }
  .article-title {
    margin-left: 20px;
  }
}
.input-container {
  width: 100%;
  margin-bottom: 20px;
  text-align: center;
  .input {
    width: 430px;
  }
}
</style>
